<template>
  <div class="preAlert">
    <van-form
      ref="formRef"
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="title" v-if="pageType == 'arrival'">ARRIVAL NOTICE</div>
      <div v-else>
        <div class="title" v-if="form.BusinessType == 1">Air Cargo Manifest</div>
        <div class="title" v-if="form.BusinessType == 2">Sea Cargo Manifest</div>
        <div class="title" v-if="form.BusinessType == 3">Air To Door Manifest</div>
        <div class="title" v-if="form.BusinessType == 4">Sea To Door Manifest</div>
        <div class="title" v-if="form.BusinessType == 5">Express Manifest</div>
      </div>
      <van-field
        v-if="form.ManifestNumber"
        v-model="form.ManifestNumber"
        label="MANIFEST NO"
        label-class="number-label"
        disabled
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            native-type="button"
            @click="onCopy(form.ManifestNumber)"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>
      <van-field
        :label="$t.preAlert.companyLogo"
        label-class="image-label"
        v-if="pageType == 'detail' || pageType == 'edit' || pageType == 'arrival'"
      >
        <template #input>
          <van-image
            width="80"
            height="80"
            fit="contain"
            :src="imgUrlFilter(form.CompanyLogoPic)"
            @click="imagePreview(imgUrlFilter(form.CompanyLogoPic))"
          />
        </template>
      </van-field>
      <van-field :label="$t.preAlert.companyLogo" label-class="image-label" v-else>
        <template #input>
          <van-image
            width="80"
            height="80"
            fit="contain"
            :src="imgUrlFilter(CompanyLogoPic)"
            @click="imagePreview(imgUrlFilter(CompanyLogoPic))"
          />
        </template>
      </van-field>
      <van-field
        v-if="pageType == 'detail' || pageType == 'edit' || pageType == 'arrival'"
        v-model="form.CompanyName"
        :label="$t.preAlert.companyName"
        type="textarea"
        rows="3"
        disabled
      />
      <van-field
        v-else
        v-model="CompanyName"
        :label="$t.preAlert.companyName"
        type="textarea"
        rows="3"
        disabled
      />

      <div class="preAlert-radio">
        <div class="radio-label-disabled">{{ $t.meta.businessType }}</div>
        <van-radio-group v-model="form.BusinessType" direction="horizontal" disabled>
          <van-radio :name="1">{{ $t.meta.wbType1 }}</van-radio>
          <van-radio :name="2">{{ $t.meta.wbType2 }}</van-radio>
          <van-radio :name="3">{{ $t.meta.wbType3 }}</van-radio>
          <van-radio :name="4">{{ $t.meta.wbType4 }}</van-radio>
          <van-radio :name="5">{{ $t.meta.wbType5 }}</van-radio>
        </van-radio-group>
      </div>

      <van-field v-model="form.PWB_Number" :label="$t.preAlert.mainWbNumber" disabled />
      <van-field v-model="form.TotalHawb" :label="$t.preAlert.totalHawb" disabled />

      <van-field
        clickable
        :disabled="!isEdit ? true : false"
        readonly
        :value="form.Pol.text"
        :label="$t.preAlert.deliveryCity"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showPreAlertPol')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        :disabled="!isEdit ? true : false"
        readonly
        :value="form.Pod.text"
        :label="$t.preAlert.destinationCity"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showPreAlertPod')"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.FlightNumber"
        :label="$t.preAlert.flightNumber"
        :placeholder="!isEdit ? '' : $t.meta.input"
        :disabled="!isEdit ? true : false"
        required
        :rules="formRule"
      />

      <div class="preAlert-radio">
        <div :class="!isEdit ? 'radio-label-disabled' : 'radio-label'">
          {{ $t.preAlert.transitshipment }}
        </div>
        <van-radio-group
          v-model="form.IsTransitshipemnt"
          direction="horizontal"
          :disabled="!isEdit ? true : false"
        >
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <van-field
        v-model="form.TotalNumber"
        :label="$t.preAlert.totalNumber"
        :placeholder="!isEdit ? '' : $t.meta.input"
        :disabled="!isEdit ? true : false"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.GrossWeight"
        :label="$t.preAlert.weight"
        :placeholder="!isEdit ? '' : $t.meta.input"
        :disabled="!isEdit ? true : false"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.Volume"
        :label="$t.preAlert.volume"
        :placeholder="!isEdit ? '' : $t.meta.input"
        :disabled="!isEdit ? true : false"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
        required
        :rules="formRule"
      />

      <div v-if="form.BusinessType == 2 && pageType != 'arrival'">
        <div class="preAlert-radio">
          <div :class="!isEdit ? 'radio-label-disabled' : 'radio-label'">
            {{ $t.preAlert.cargoType }}
          </div>
          <van-radio-group
            v-model="form.CargoType"
            direction="horizontal"
            :disabled="!isEdit ? true : false"
          >
            <van-radio :name="1">FCL</van-radio>
            <van-radio :name="2">LCL</van-radio>
          </van-radio-group>
        </div>

        <van-field
          v-model="form.CargoTotalCategory_20"
          label="x 20'"
          :placeholder="!isEdit ? '' : $t.meta.input"
          :disabled="!isEdit ? true : false"
        />

        <van-field
          v-model="form.CargoTotalCategory_40"
          label="x 40'"
          :placeholder="!isEdit ? '' : $t.meta.input"
          :disabled="!isEdit ? true : false"
        />

        <van-field
          v-model="form.CargoTotalCategory_40hq"
          label="x 40hq'"
          :placeholder="!isEdit ? '' : $t.meta.input"
          :disabled="!isEdit ? true : false"
        />

        <van-field
          v-model="form.CargoTotalCategory_Others"
          label="x other"
          :placeholder="!isEdit ? '' : $t.meta.input"
          :disabled="!isEdit ? true : false"
        />
      </div>

      <div :class="!isEdit ? 'custom-date-disabled' : 'custom-date'">
        <div class="date-btn1">{{ $t.preAlert.etd }}</div>
        <div class="date-btn2" @click="showTimeDate('ETD')">
          <span v-if="form.ETD" class="value">{{ form.ETD }}</span>
          <span v-else class="placeholder">{{ $t.meta.select }}</span>
        </div>
      </div>

      <div :class="!isEdit ? 'custom-date-disabled' : 'custom-date'">
        <div class="date-btn1">{{ $t.preAlert.atd }}</div>
        <div class="date-btn2" @click="showTimeDate('ATD')">
          <span v-if="form.ATD" class="value">{{ form.ATD }}</span>
          <span v-else class="placeholder">{{ $t.meta.select }}</span>
        </div>
      </div>

      <div :class="!isEdit ? 'custom-date-disabled' : 'custom-date'">
        <div class="date-btn1">{{ $t.preAlert.eta }}</div>
        <div class="date-btn2" @click="showTimeDate('ETA')">
          <span v-if="form.ETA" class="value">{{ form.ETA }}</span>
          <span v-else class="placeholder">{{ $t.meta.select }}</span>
        </div>
      </div>

      <van-field
        :value="form.ATA"
        :label="$t.preAlert.ata"
        :disabled="!isEdit ? true : false"
        readonly
      />

      <van-field
        v-model="form.ShipperCustomer.text"
        label="SHIPPER"
        :placeholder="!isEdit ? '' : $t.meta.select"
        @click="onShowEmit('showPreAlertShipperCustomer')"
        clickable
        :disabled="!isEdit ? true : false"
        readonly
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.ConsigneeCustomer.text"
        label="CONSIGNEE"
        :placeholder="!isEdit ? '' : $t.meta.select"
        @click="onShowEmit('showPreAlertConsigneeCustomer')"
        clickable
        :disabled="!isEdit ? true : false"
        readonly
        required
        :rules="formRule"
      />

      <div class="title">{{ $t.preAlert.total }}</div>
      <van-field :value="form.DetailTotalNumber + ' CTN ONLY'" label="TOTAL" readonly />
      <van-field :value="form.DetailTotalWeight + ' KG'" label="Weight" readonly />
      <van-field :value="form.DetailTotalVolume" label="Volume" readonly />

      <div class="title">{{ $t.preAlert.others }}</div>
      <van-field
        v-if="pageType == 'arrival'"
        v-model="arrivalRemark"
        :label="$t.preAlert.remark"
        type="textarea"
        rows="5"
        :placeholder="$t.meta.input"
      />
      <van-field
        v-else
        v-model="form.Remark"
        :label="$t.preAlert.remark"
        type="textarea"
        rows="5"
        :placeholder="!isEdit ? '' : $t.preAlert.remarkPlaceHolder"
        :disabled="!isEdit ? true : false"
      />
      <van-field
        :label="$t.preAlert.printRemark"
        readonly
        v-if="pageType == 'detail' || pageType == 'edit'"
      >
        <template #right-icon>
          <van-switch
            v-model="isPrintRemark"
            :active-value="true"
            :inactive-value="false"
            size="24"
          />
        </template>
      </van-field>

      <div class="title">{{ $t.preAlert.detailList }}</div>
      <div class="list-container" v-for="(item, index) in form.DetailList" :key="index">
        <div class="list-item">HAWB#：{{ item.WB_Number }}</div>
        <div class="list-item">CTN：{{ item.CTN }}</div>
        <div class="list-item">WEIGHT：{{ item.Weight }}</div>
        <div class="list-item">VOLUME：{{ item.Volume }}</div>
        <div class="list-item">DEST：{{ item.Dest }}</div>
        <div class="list-item">DESCRIPTION：{{ item.Description }}</div>
        <div class="list-item">P/C：{{ item.PC }}</div>
        <div class="list-item">SHIPPER：{{ item.Shipper }}</div>
        <div class="list-item">CONSIGNEE：{{ item.Consignee }}</div>
        <div class="list-item" v-if="form.BusinessType == 2">
          NOTIFY：{{ item.Notify }}
        </div>
        <div class="list-item-radio" v-if="form.BusinessType == 2">
          <div class="radio-label">DG GOODS</div>
          <van-radio-group
            v-model="item.DgGoods"
            direction="horizontal"
            :disabled="!isEdit ? true : false"
          >
            <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
            <van-radio :name="0">{{ $t.meta.no }}</van-radio>
          </van-radio-group>
        </div>
        <div class="list-item" v-if="form.BusinessType == 2">
          CONTAINER：{{ item.Container }}
        </div>
        <div class="list-table">
          <div class="list-table-label">COLLECT INVOICE：</div>
          <div v-if="item.DetailList.length > 0">
            <div
              v-for="(detail, pIdx) in item.DetailList"
              :key="pIdx"
              class="list-table-value"
            >
              <div
                v-for="(invoice, cIdx) in detail.InvoiceList"
                :key="cIdx"
                @click="toBillsReceivable(invoice)"
                class="invoice"
              >
                {{ invoice }}
              </div>
            </div>
          </div>
          <div v-else class="list-table-empty">{{ $t.meta.noData }}</div>
        </div>
        <div class="buttons">
          <van-badge :content="item.PL_FileList.length ? item.PL_FileList.length : null">
            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              native-type="button"
              @click="dialogShow(item.WB_Number, 1, index, 'PL')"
              >PL</van-button
            >
          </van-badge>
          <van-badge
            :content="item.INV_FileList.length ? item.INV_FileList.length : null"
          >
            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              native-type="button"
              @click="dialogShow(item.WB_Number, 2, index, 'INV')"
              >INV</van-button
            >
          </van-badge>
          <van-badge :content="item.CO_FileList.length ? item.CO_FileList.length : null">
            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              native-type="button"
              @click="dialogShow(item.WB_Number, 3, index, 'CO')"
              >CO</van-button
            >
          </van-badge>
          <van-badge
            :content="item.CCPIT_FileList.length ? item.CCPIT_FileList.length : null"
          >
            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              native-type="button"
              @click="dialogShow(item.WB_Number, 4, index, 'CCPIT')"
              >CCPIT</van-button
            >
          </van-badge>
          <van-badge
            :content="item.OTHER_FileList.length ? item.OTHER_FileList.length : null"
          >
            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              native-type="button"
              @click="dialogShow(item.WB_Number, 5, index, 'OTHER')"
              >OTHER</van-button
            >
          </van-badge>
        </div>
      </div>

      <div style="margin: 16px">
        <!-- 生成工作单 -->
        <van-button
          round
          block
          type="info"
          native-type="button"
          style="margin-top: 10px"
          @click="createWorkOrderByPreAlert"
          v-if="pageType == 'detail' && form.AlertState != 1"
        >
          {{ $t.preAlert.workSheet }}
        </van-button>

        <!-- 内部推送 -->
        <van-button
          round
          block
          type="warning"
          native-type="button"
          style="margin-top: 10px"
          @click="pushShow"
          v-if="isEdit && form.AlertState != 1"
          :disabled="!form.PAId ? true : false"
        >
          {{ $t.preAlert.button1 }}
        </van-button>

        <!-- 停用 -->
        <van-button
          round
          block
          type="default"
          native-type="button"
          style="margin-top: 10px"
          @click="updateState"
          v-if="pageType == 'edit'"
        >
          <span v-if="form.AlertState">{{ $t.meta.enable }}</span>
          <span v-else>{{ $t.meta.disable }}</span>
        </van-button>

        <!-- 打印 -->
        <van-button
          round
          block
          type="default"
          native-type="button"
          style="margin-top: 10px"
          @click="gotoPrint"
          v-if="pageType == 'detail' || pageType == 'edit'"
        >
          {{ $t.meta.print }}
        </van-button>
        <van-button
          round
          block
          type="default"
          native-type="button"
          style="margin-top: 10px"
          @click="arrivalPrint"
          v-if="pageType == 'arrival'"
        >
          {{ $t.meta.print }}
        </van-button>

        <!-- 发送邮件 -->
        <van-button
          round
          block
          type="default"
          style="margin-top: 10px"
          native-type="button"
          @click="emailVisible = true"
          v-if="pageType == 'detail' || pageType == 'edit' || pageType == 'arrival'"
        >
          {{ $t.preAlert.button2 }}
        </van-button>
      </div>

      <div class="tool-bar" v-if="isEdit">
        <van-button type="info" block native-type="submit">{{ $t.meta.save }}</van-button>
      </div>
    </van-form>

    <option-list
      event="showPreAlertShipperCustomer"
      :options="customerInfoList"
      @onSelect="onSelectShipperCustomer"
    ></option-list>

    <option-list
      event="showPreAlertConsigneeCustomer"
      :options="customerInfoList"
      @onSelect="onSelectConsigneeCustomer"
    ></option-list>

    <option-list
      event="showPreAlertPol"
      :options="countryList"
      @onSelect="onSelectPol"
    ></option-list>

    <option-list
      event="showPreAlertPod"
      :options="countryList"
      @onSelect="onSelectPod"
    ></option-list>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="dateTimeTitle"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-dialog
      :title="$t.preAlert.preAlertTitle"
      width="90%"
      v-model="filesVisible"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.close"
      :show-cancel-button="true"
      :show-confirm-button="false"
    >
      <slot name="default">
        <div class="preAlert-alert">
          <van-form label-width="120px">
            <div class="multi-table" v-if="form.DetailList[filesForm.index]">
              <van-field name="stepper" :label="filesForm.title">
                <template #input>
                  <van-stepper
                    :min="0"
                    :value="form.DetailList[filesForm.index][filesForm.param].length"
                    @minus="handleDel"
                    @plus="handleAdd"
                    :disable-input="true"
                    :disabled="!isEdit ? true : false"
                  />
                </template>
              </van-field>
              <div
                v-for="(item, index) in form.DetailList[filesForm.index][filesForm.param]"
                :key="index"
              >
                <div class="multi-table-header" v-if="isEdit">
                  <div class="multi-table-title"></div>
                  <div class="multi-table-btn" @click="handleDelByIndex(index)">
                    <van-icon name="close" />
                  </div>
                </div>
                <van-field :label="'No.' + (index + 1)">
                  <template #input>
                    <van-button
                      @click="imagePreview(imgUrlFilter(item.FileAddress))"
                      type="primary"
                      size="small"
                      style="vertical-align: top; margin: 10px 30px 10px 0px"
                      v-if="item.FileAddress"
                      >{{ $t.meta.view }}</van-button
                    >
                    <van-uploader
                      :after-read="afterRead"
                      @click-upload="uploaderClick(index)"
                    >
                      <van-image
                        :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                        width="50"
                        height="50"
                        fit="contain"
                        style="vertical-align: top"
                        v-if="item.FileAddress"
                      ></van-image>
                      <van-button
                        type="info"
                        size="small"
                        style="vertical-align: top; margin: 10px 30px 10px 0px"
                        v-else
                        >{{ $t.meta.upload }}</van-button
                      >
                    </van-uploader>
                  </template>
                </van-field>
              </div>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      title="Pre-Alert Receiver"
      width="90%"
      v-model="pushVisible"
      @cancel="pushVisible = false"
      @confirm="pushSubmit"
      :cancel-button-text="$t.meta.close"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="preAlert-alert">
          <van-form label-width="120px">
            <van-field
              :label="$t.preAlert.companyCode"
              v-model="pushForm.CompanyCode"
              :placeholder="$t.meta.input"
              required
            >
              <template #button>
                <van-button
                  size="small"
                  type="primary"
                  @click="getUserListByCompanyCode"
                  >{{ $t.meta.search }}</van-button
                >
              </template>
            </van-field>

            <van-field
              clickable
              readonly
              :label="$t.preAlert.companyUser"
              :value="pushForm.PushUserListText"
              type="textarea"
              rows="5"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showPreAlertUser')"
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.preAlert.button2"
      width="90%"
      v-model="emailVisible"
      @cancel="emailVisible = false"
      @confirm="onSendEmail"
      :cancel-button-text="$t.meta.close"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="preAlert-alert">
          <van-form label-width="80px">
            <van-field
              v-model="emailForm.email"
              :label="$t.preAlert.email"
              :placeholder="$t.preAlert.placeholderEmail"
              type="textarea"
              rows="5"
              required
            />
            <div class="preAlert-checkbox-label" v-if="pageType == 'arrival'">
              {{ $t.preAlert.emailLabel }}
            </div>
            <div class="preAlert-checkbox" v-if="pageType == 'arrival'">
              <van-checkbox-group
                v-model="emailForm.fileDetailList"
                direction="horizontal"
              >
                <van-checkbox :name="1">PL</van-checkbox>
                <van-checkbox :name="2">INV</van-checkbox>
                <van-checkbox :name="3">CO</van-checkbox>
                <van-checkbox :name="4">CCPIT</van-checkbox>
                <van-checkbox :name="5">OTHER</van-checkbox>
                <van-checkbox :name="6">{{ $t.preAlert.file1 }}</van-checkbox>
                <van-checkbox :name="7">{{ $t.preAlert.file2 }}</van-checkbox>
              </van-checkbox-group>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showWarehouseDialog"
      @confirm="toWarehouseBill"
      @cancel="showWarehouseDialog = false"
      :confirm-button-text="$t.meta.yes"
      :cancel-button-text="$t.meta.no"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.preAlert.noticeText }}
      </div>
    </van-dialog>

    <check-list
      event="showPreAlertUser"
      :options="userOptions"
      @onSelect="onSelectUser"
    ></check-list>
  </div>
</template>
<script>
import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
import CheckList from "@components/checkList/CheckList.vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
  Badge,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker)
  .use(Badge);

export default {
  name: "preAlert",
  components: {
    OptionList,
    CheckList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      CompanyName: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyName,
      CompanyLogoPic: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyLogoPic,
      pageType: "new",
      WB_NumberList: [],
      WB_Number: "",
      PAId: "",
      isEdit: false,
      form: {
        PAId: 0,
        ManifestNumber: "",
        PWB_Number: "",
        TotalHawb: "",
        IssueCompanyId: 0,
        CompanyName: "",
        CompanyLogoPic: "",
        BusinessType: 1,
        Pol: {},
        Pod: {},
        FlightNumber: "",
        ShipperCustomer: {},
        ConsigneeCustomer: {},
        IsTransitshipemnt: 0,
        TotalNumber: "",
        GrossWeight: "",
        Volume: "",
        CargoType: 1,
        CargoTotalCategory_20: "",
        CargoTotalCategory_40: "",
        CargoTotalCategory_40hq: "",
        CargoTotalCategory_Others: "",
        ETD: "",
        ATD: "",
        ETA: "",
        ATA: "",
        Remark: "",
        IsUploadMawbFile: "",
        DetailList: [],
        DetailTotalNumber: "",
        DetailTotalWeight: "",
        DetailTotalVolume: "",
        DetailTotalCategory_20: "",
        DetailTotalCategory_40: "",
        DetailTotalCategory_40hq: "",
        DetailTotalCategory_Others: "",
        AlertState: 0,
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      detailList: [],
      //选项
      countryList: [],
      customerInfoList: [],
      //日期
      selectDate: new Date(),
      dateTimeType: "ETD",
      dateTimeTitle: this.$t.preAlert.etd,
      showTimePicker: false,
      currentDate: "",
      //文件列表
      filesVisible: false,
      filesForm: {
        id: "",
        title: "",
        type: "",
        param: "PL_FileList",
        index: 0,
      },
      filesIndex: 0,
      isPrintRemark: true,
      arrivalRemark: "",
      //内部推送
      userOptions: [],
      pushVisible: false,
      pushForm: {
        CompanyCode: "",
        PushUserListText: "",
        PushUserList: [],
      },
      //发送邮件
      emailVisible: false,
      emailForm: {
        email: "",
        fileDetailList: [7],
      },
      showWarehouseDialog: false,
    };
  },
  created() {
    const { Type, WB_NumberList, PAId, WB_Number } = this.$route.query;
    this.pageType = Type;
    let addAction = () => {
      this.getCountrys(this.form.BusinessType);
      this.getCustomerInfoSearchList();
    };
    let editAction = () => {
      this.isEdit = true;
      this.getCountrys(this.form.BusinessType);
      this.getCustomerInfoSearchList();
    };
    let detailAction = () => {
      this.isEdit = false;
      this.getCountrys(this.form.BusinessType);
    };
    if (this.pageType == "new") {
      this.isEdit = true;
      this.WB_NumberList = WB_NumberList;
      this.loadPreAlertInfo().then((success) => {
        if (success) {
          addAction();
        }
      });
    } else if (this.pageType == "edit") {
      this.PAId = PAId;
      this.getPreAlertInfo().then((success) => {
        if (success) {
          editAction();
        }
      });
    } else if (this.pageType == "arrival") {
      this.WB_Number = WB_Number;
      this.getArrivalNoticeDetail().then((success) => {
        if (success) {
          detailAction();
        }
      });
    } else {
      this.PAId = PAId;
      this.getPreAlertInfo().then((success) => {
        if (success) {
          detailAction();
        }
      });
    }
  },
  methods: {
    updateState() {
      this.$commonMethod.showLoading();
      var param = {
        PAId: this.form.PAId,
      };
      this.$api.logisticsManagement
        .editPreAlertState(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.getPreAlertInfo().then((success) => {
            if (success) {
              editAction();
            }
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    createWorkOrderByPreAlert() {
      this.$commonMethod.showLoading();
      var param = {
        PAId: this.form.PAId,
      };
      this.$api.logisticsManagement
        .createWorkOrderByPreAlert(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.form.AlertState = 1;
          if (this.form.BusinessType == 5) {
            this.showWarehouseDialog = true;
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    toWarehouseBill() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "warehouseBill",
        name: "warehouseBill",
        query: [
          {
            name: "PAId",
            value: this.form.PAId,
          },
          {
            name: "ManifestNumber",
            value: this.form.ManifestNumber,
          },
        ],
      });
    },
    onSendEmail() {
      if (this.pageType == "arrival") {
        this.sendFileDetailsEmail();
      } else {
        this.sendMailByPreAlertFile();
      }
    },
    sendFileDetailsEmail() {
      this.$commonMethod.showLoading();
      var param = {
        WB_Number: this.WB_Number,
        Email: this.emailForm.email,
        Remark: this.arrivalRemark,
        FileDetailList: this.emailForm.fileDetailList,
      };
      this.$api.logisticsManagement
        .sendFileDetailsEmail(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.emailVisible = false;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    sendMailByPreAlertFile() {
      this.$commonMethod.showLoading();
      var param = {
        PAId: this.form.PAId,
        ConsigneeCustomerId: this.form.ConsigneeCustomer.value,
        Email: this.emailForm.email,
      };
      this.$api.logisticsManagement
        .sendMailByPreAlertFile(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.emailVisible = false;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onSelectUser(e) {
      var users = [];
      this.pushForm.PushUserListText = e.map((option) => option.text).join(" , ");
      for (var user of e) {
        if (user.value) {
          users.push(user.value);
        }
      }
      this.pushForm.PushUserList = users;
      this.$forceUpdate();
    },
    pushSubmit() {
      var userList = [];
      for (var id of this.pushForm.PushUserList) {
        userList.push({
          UserId: parseInt(id),
        });
      }
      this.$commonMethod.showLoading();
      var param = {
        PAId: this.form.PAId,
        CompanyId: this.userOptions[0].CompanyId,
        PushUserList: userList,
      };
      this.$api.logisticsManagement
        .vtrackInternaPush(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.pushVisible = false;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    pushShow() {
      this.pushVisible = true;
    },
    getUserListByCompanyCode() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          CompanyCode: this.pushForm.CompanyCode,
        };
        this.$api.user
          .getUserListByCompanyCode(param)
          .then((res) => {
            var userOptions = [];
            res.data.forEach((item) => {
              let data = {
                text: item.UserName,
                value: item.UserId,
                CompanyId: item.CompanyId,
              };
              userOptions.push(data);
            });
            this.userOptions = userOptions;
            this.onShowEmit("showPreAlertUser");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    toBillsReceivable(invoiceNo) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "billsReceivable",
        name: "billsReceivable",
        query: [
          {
            name: "InvoiceNo",
            value: invoiceNo,
          },
          {
            name: "IsExternal",
            value: this.pageType == "detail" ? true : false,
          },
        ],
      });
    },
    dialogShow(id, type, index, title) {
      this.filesForm.id = id;
      this.filesForm.type = type;
      if (type == 1) {
        this.filesForm.param = "PL_FileList";
      }
      if (type == 2) {
        this.filesForm.param = "INV_FileList";
      }
      if (type == 3) {
        this.filesForm.param = "CO_FileList";
      }
      if (type == 4) {
        this.filesForm.param = "CCPIT_FileList";
      }
      if (type == 5) {
        this.filesForm.param = "OTHER_FileList";
      }
      this.filesForm.index = index;
      this.filesForm.title = title;
      this.filesVisible = true;
    },
    onSelectShipperCustomer(e) {
      this.form.ShipperCustomer.text = e.text;
      this.form.ShipperCustomer.value = e.value;
      this.form.ShipperCustomer.CustomerNumber = e.CustomerNumber;
      this.$forceUpdate();
    },
    onSelectConsigneeCustomer(e) {
      this.form.ConsigneeCustomer.text = e.text;
      this.form.ConsigneeCustomer.value = e.value;
      this.form.ConsigneeCustomer.CustomerNumber = e.CustomerNumber;
      this.$forceUpdate();
    },
    onSelectPol(e) {
      this.form.Pol.text = e.text;
      this.form.Pol.value = e.value;
      this.form.Pol.CountryId = e.CountryId;
      this.$forceUpdate();
    },
    onSelectPod(e) {
      this.form.Pod.text = e.text;
      this.form.Pod.value = e.value;
      this.form.Pod.CountryId = e.CountryId;
      this.$forceUpdate();
    },
    onShowEmit(emit) {
      if (!this.isEdit) {
        return;
      }
      this.$bus.$emit(emit, true);
    },
    getArrivalNoticeDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          WB_Number: this.WB_Number,
        };
        this.$api.logisticsManagement
          .getArrivalNoticeDetail(param)
          .then((res) => {
            this.applyData(res.data, "arrival");
            this.detailList = this.$commonMethod.deepClone(this.form.DetailList);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    loadPreAlertInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          WB_NumberList: this.WB_NumberList,
        };
        this.$api.logisticsManagement
          .loadPreAlertInfo(param)
          .then((res) => {
            this.applyData(res.data, "new");
            this.detailList = this.$commonMethod.deepClone(this.form.DetailList);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    getPreAlertInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          PAId: this.PAId,
        };
        this.$api.logisticsManagement
          .getPreAlertInfo(param)
          .then((res) => {
            this.applyData(res.data, "detail");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    applyData(data, type) {
      if (type == "new") {
        this.form.PWB_Number = data.PWB_Number;
        this.form.TotalHawb = data.TotalHawb;
        this.form.BusinessType = data.BusinessType;
        this.form.IsUploadMawbFile = data.IsUploadMawbFile;
      }
      this.form.PAId = data.PAId;
      this.form.ManifestNumber = data.ManifestNumber;
      this.form.PWB_Number = data.PWB_Number;
      this.form.TotalHawb = data.TotalHawb;
      this.form.IssueCompanyId = data.IssueCompanyId;
      this.form.CompanyName = data.CompanyName;
      this.form.CompanyLogoPic = data.CompanyLogoPic;
      this.form.BusinessType = data.BusinessType;
      this.form.Pol = {
        text: data.Pol,
        value: data.PolCityId,
        CountryId: data.PolCountryId,
      };
      this.form.Pod = {
        text: data.Pod,
        value: data.PodCityId,
        CountryId: data.PodCountryId,
      };
      this.form.FlightNumber = data.FlightNumber;
      this.form.ShipperCustomer = {
        text: data.ShipperCustomerName,
        value: data.ShipperCustomerId,
      };
      this.form.ConsigneeCustomer = {
        text: data.ConsigneeCustomerName,
        value: data.ConsigneeCustomerId,
      };
      this.form.IsTransitshipemnt = data.IsTransitshipemnt;
      this.form.TotalNumber = data.TotalNumber;
      this.form.GrossWeight = data.GrossWeight;
      this.form.Volume = data.Volume;
      this.form.CargoType = data.CargoType;
      this.form.CargoTotalCategory_20 = data.CargoTotalCategory_20;
      this.form.CargoTotalCategory_40 = data.CargoTotalCategory_40;
      this.form.CargoTotalCategory_40hq = data.CargoTotalCategory_40hq;
      this.form.CargoTotalCategory_Others = data.CargoTotalCategory_Others;
      this.form.ETD = data.ETD;
      this.form.ATD = data.ATD;
      this.form.ETA = data.ETA;
      this.form.ATA = data.ATA;
      this.form.Remark = data.Remark;
      this.form.IsUploadMawbFile = data.IsUploadMawbFile;
      this.form.DetailList = data.DetailList;
      this.form.DetailTotalNumber = data.DetailTotalNumber;
      this.form.DetailTotalWeight = data.DetailTotalWeight;
      this.form.DetailTotalVolume = data.DetailTotalVolume;
      this.form.DetailTotalCategory_20 = data.DetailTotalCategory_20;
      this.form.DetailTotalCategory_40 = data.DetailTotalCategory_40;
      this.form.DetailTotalCategory_40hq = data.DetailTotalCategory_40hq;
      this.form.DetailTotalCategory_Others = data.DetailTotalCategory_Others;
      this.form.AlertState = data.AlertState;
    },
    onSubmit() {
      if (!this.form.ShipperCustomer.value) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.select + " SHIPPER",
          type: "danger",
        });
        return false;
      }

      if (!this.form.ConsigneeCustomer.value) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.select + " CONSIGNEE",
          type: "danger",
        });
        return false;
      }

      this.$commonMethod.showLoading();
      var detailList = [];
      for (const sDetail of this.form.DetailList) {
        detailList.push({
          PARId: sDetail.PARId,
          WB_Number: sDetail.WB_Number,
          IsDgGoods: sDetail.DgGoods,
          PL_FileList: sDetail.PL_FileList,
          INV_FileList: sDetail.INV_FileList,
          CO_FileList: sDetail.CO_FileList,
          CCPIT_FileList: sDetail.CCPIT_FileList,
          OTHER_FileList: sDetail.OTHER_FileList,
        });
      }
      const param = {
        PAId: this.form.PAId,
        PWB_Number: this.form.PWB_Number,
        BusinessType: this.form.BusinessType,
        PolCountryId: this.form.Pol.CountryId,
        PolCityId: this.form.Pol.value,
        PodCountryId: this.form.Pod.CountryId,
        PodCityId: this.form.Pod.value,
        FlightNumber: this.form.FlightNumber,
        ShipperCustomerId: this.form.ShipperCustomer.value,
        ConsigneeCustomerId: this.form.ConsigneeCustomer.value,
        IsTransitshipemnt: this.form.IsTransitshipemnt,
        TotalNumber: this.form.TotalNumber,
        GrossWeight: this.form.GrossWeight,
        Volume: this.form.Volume,
        CargoType: this.form.CargoType,
        CargoTotalCategory_20: this.form.CargoTotalCategory_20,
        CargoTotalCategory_40: this.form.CargoTotalCategory_40,
        CargoTotalCategory_40hq: this.form.CargoTotalCategory_40hq,
        CargoTotalCategory_Others: this.form.CargoTotalCategory_Others,
        ETD: this.form.ETD,
        ATD: this.form.ATD,
        ETA: this.form.ETA,
        Remark: this.form.Remark,
        WaybillRecordList: detailList,
      };
      var request = null;
      if (this.pageType == "edit") {
        request = this.$api.logisticsManagement.editPreAlertInfo(param);
      } else {
        request = this.$api.logisticsManagement.savePreAlertInfo(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCountrys(type) {
      return new Promise((resolve) => {
        let param = {};
        if (type == 2 || type == 4) {
          param.type = 2;
        } else {
          param.type = 1;
        }
        this.$api.logisticsManagement
          .getCountryList(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName_en + " , " + item.City_en,
                value: item.Id,
                CountryId: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCustomerInfoSearchList() {
      return new Promise((resolve) => {
        let param = {
          CompanyId: this.CompanyId,
        };
        this.$api.customerManagement
          .getCustomerInfoSearchList(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CompanyNameEn ? item.CompanyNameEn : item.CompanyName,
                value: item.CustomerId,
              };
              result.push(data);
            });
            this.customerInfoList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    showTimeDate(type) {
      if (!this.isEdit) {
        return;
      }
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.dateTimeType = type;
      if (type == "ETD") {
        this.dateTimeTitle = this.$t.preAlert.etd;
      }
      if (type == "ATD") {
        this.dateTimeTitle = this.$t.preAlert.atd;
      }
      if (type == "ETA") {
        this.dateTimeTitle = this.$t.preAlert.eta;
      }
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (this.dateTimeType == "ETD") {
        this.form.ETD = formatDate(date);
      }
      if (this.dateTimeType == "ATD") {
        this.form.ATD = formatDate(date);
      }
      if (this.dateTimeType == "ETA") {
        this.form.ETA = formatDate(date);
      }
      this.showTimePicker = false;
    },
    handleAdd() {
      var files = this.form.DetailList[this.filesForm.index][this.filesForm.param];
      files.push({
        FileAddress: "",
      });
    },
    handleDel() {
      var files = this.form.DetailList[this.filesForm.index][this.filesForm.param];
      if (files && files.length > 0) {
        files.pop();
      }
    },
    handleDelByIndex(index) {
      var files = this.form.DetailList[this.filesForm.index][this.filesForm.param];
      files.splice(index, 1);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead(file) {
      let index = this.filesForm.index;
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          for (const detail of this.form.DetailList) {
            if (detail.WB_Number == this.filesForm.id) {
              if (this.filesForm.type == 1) {
                this.form.DetailList[index].PL_FileList[this.filesIndex].FileAddress =
                  res.data;
              }
              if (this.filesForm.type == 2) {
                this.form.DetailList[index].INV_FileList[this.filesIndex].FileAddress =
                  res.data;
              }
              if (this.filesForm.type == 3) {
                this.form.DetailList[index].CO_FileList[this.filesIndex].FileAddress =
                  res.data;
              }
              if (this.filesForm.type == 4) {
                this.form.DetailList[index].CCPIT_FileList[this.filesIndex].FileAddress =
                  res.data;
              }
              if (this.filesForm.type == 5) {
                this.form.DetailList[index].OTHER_FileList[this.filesIndex].FileAddress =
                  res.data;
              }
            }
          }
        })
        .catch(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    gotoPrint() {
      var param = {
        PAId: this.PAId,
        IsPrintRemark: this.isPrintRemark,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createPreAlertFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    arrivalPrint() {
      var param = {
        WB_Number: this.WB_Number,
        Remark: this.arrivalRemark,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createArrivalNoticeFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.preAlert {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .image-label {
    color: #999 !important;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #999 !important;
    -webkit-text-fill-color: #999 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  .cost-title {
    font-weight: bold;
    font-size: 14px;
    margin-top: 20px;
    padding: 10px;
    background: #e4f6f0;
    color: #20b2aa;
    border: 2px solid #20b2aa;
  }
  .sale-title {
    font-weight: bold;
    font-size: 14px;
    margin-top: 20px;
    padding: 10px;
    background: #e8f4ff;
    color: #1e90ff;
    border: 2px solid #87ceeb;
  }
  .preAlert-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label-disabled {
      color: #999;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .preAlert-checkbox-label {
    padding-top: 15px;
    padding-left: 15px;
    font-size: 14px;
    color: #646566;
  }
  .preAlert-checkbox {
    padding: 20px;
    .van-checkbox {
      margin-bottom: 20px;
      font-size: 14px;
    }
  }
  .custom-date-disabled {
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #999 !important;
    }
    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #999 !important;
      }
      .placeholder {
        color: #999 !important;
      }
    }
  }
  .custom-date {
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
    }
    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
  .list-container {
    font-size: 12px;
    color: #333;
    padding: 10px;
    box-shadow: 0px 2.5px 5px 2.5px rgba(0, 0, 0, 0.2);
    .list-item {
      margin-bottom: 10px;
      width: 50%;
      display: inline-block;
      vertical-align: top;
    }
    .list-item:nth-last-child(2) {
      margin-bottom: 0px;
    }
    .list-item:last-child {
      margin-bottom: 0px;
    }
    .list-item-radio {
      width: 50%;
      display: inline-block;
      vertical-align: middle;
      margin-bottom: 10px;
      .radio-label {
        color: #333;
        margin-bottom: 10px;
        font-size: 12px;
      }
      .van-radio {
        margin-right: 20px;
        margin-bottom: 0px;
        font-size: 12px;
      }
    }
    .list-table {
      margin-bottom: 20px;
      width: 100%;
      display: inline-block;
      .list-table-label {
        color: #333;
      }
      .list-table-value {
        color: $-color-primary;
        font-size: 14px;
        .invoice {
          width: 50%;
          margin-top: 10px;
          display: inline-block;
        }
      }
      .list-table-empty {
        margin-top: 10px;
        color: #c3c3c3;
      }
    }
    .buttons {
      text-align: right;
      .van-badge__wrapper {
        width: 20%;
        text-align: center;
        ::v-deep .van-badge {
          right: 5px !important;
        }
        button {
          width: 80%;
        }
      }
      .primary-btn {
        border-radius: 5px;
        background: #1989fa;
        border: none;
        .van-button__text {
          font-size: 14px !important;
        }
      }
    }
  }
  .preAlert-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    margin-bottom: 30px;
    .multi-table {
      .multi-table-header {
        padding: 10px 15px;
        .multi-table-title {
          font-size: 14px;
          color: #999;
          display: inline-block;
          vertical-align: middle;
        }
        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 100%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
